export enum MailingChannel {
    EMAIL = 'E',
    PAPER = 'K'
}
